import { render, staticRenderFns } from "./OpenCustomer.vue?vue&type=template&id=21ebbe4e&scoped=true&"
import script from "./OpenCustomer.vue?vue&type=script&lang=js&"
export * from "./OpenCustomer.vue?vue&type=script&lang=js&"
import style0 from "./OpenCustomer.vue?vue&type=style&index=0&id=21ebbe4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ebbe4e",
  null
  
)

export default component.exports